<template>
    <div class="container">
        <div class="container-main">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column type="index" align="center" width="60"></el-table-column>
                <el-table-column prop="username" :label="$t('userName')" align="center" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="email" :label="$t('email')" align="center" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createdAt" :label="$t('creationTime')" align="center" width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createdAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="content" :label="$t('feedbackContent')" align="center" min-width="260"></el-table-column>
            </el-table>
            <el-pagination
                background
                :current-page="currentPage"
                layout="sizes, prev, pager, next, total"
                :page-sizes="[10, 15, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {queryFeedbackList} from "@/api/modules/api";

export default {
    name: "FeedbackList",
    // 组件
    components: {
   
    },
    props: {},
    data() {
        return {
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取数据列表
        getListData() {
            const params = {
                page: this.currentPage,
                size: this.pageSize
            }
            queryFeedbackList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                    // 检验是否列表为空
                    if (this.tableData.length === 0 && this.currentPage > 1) {
                        this.currentPage--
                        this.getListData()
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
        // 获取列表数据
        this.getListData()
    },
    // 销毁之前
    beforeDestroy() {
    },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
</style>
